
import { Prop, Component, FormModalMixins, $util } from "@/lib";

class ChangePassword {
  currentPassword: string;
  newPassword: string;
  confirmNewPassword: string;
}

@Component({ name: "change-password-view" })
export default class ChangePasswordView extends FormModalMixins {
  @Prop({ type: Boolean, default: false }) isFirstLogin: boolean;
  model = new ChangePassword();
  lang = $util.basic.localization.currentLanguageName;
  created() {
    Object.assign(this.config, { modelTitleL: "Users.ChangePassword", labelWidth: 100, okAction: "currentUser/changePassword" });
  }
  validatorData(rule, value, callback) {
    if (value !== this.model.newPassword) {
      callback(new Error(this.L("app.ChangePassword.ConfirmPasswordError")));
    } else {
      callback();
    }
  }

  formValidateRule = {
    confirmPassword: [
      {
        validator: this.validatorData,
        trigger: "blur",
      },
    ],
  };
}
